import splitUrlPiece from './splitUrlPiece';

/**
 * Splits a URL in half by a `#`
 */
const splitHashParams = splitUrlPiece.bind(null, '#');

export default splitHashParams;
